export interface SiteSettingsJson {
    locale: {
        timezone: string
    }

    shift_wizard?: {
        form?: {
            defaults?: {
                approval_required: boolean
                open: boolean
            }

            edit?: {
                approval_required: boolean
            }
        }
    }
}

type ShiftWizardSettings = {
    form: {
        approvalRequired: {
            default: boolean
            editable: boolean
        }
        open: {
            default: boolean
        }
    }
}

export class SiteSettings {
    timezone: string

    shiftWizard: ShiftWizardSettings

    constructor (
        timezone: string,
        shiftWizard: ShiftWizardSettings,
    ) {
        this.timezone = timezone
        this.shiftWizard = shiftWizard
    }

    static fromJson(json: SiteSettingsJson): SiteSettings {
        return new SiteSettings(
            json.locale.timezone,
            {
                form: {
                    approvalRequired: {
                        default: json.shift_wizard?.form?.defaults?.approval_required ?? false,
                        editable: json.shift_wizard?.form?.edit?.approval_required ?? true,
                    },
                    open: {
                        default: json.shift_wizard?.form?.defaults?.open ?? false,
                    },
                },
            },
        )
    }
}
